export default __webpack_public_path__ + "static/media/quas_icon.6d680fcf.png";